module.exports = __webpack_public_path__ + "static/media/4-6.e843f9e4.mp3";